<div class="p-sidebar gz-sidebar flex flex-column justify-content-between p-3">
	<div class="overflow-y-auto">
		<gz-panelMenu styleClass="block mb-5" [arrowRight]="true" [model]="items" [multiple]="false"></gz-panelMenu>
	</div>
</div>
